// Swiper is imported already

if (!customElements.get('product-detail-swiper')) {
  class ProductDetailSwiper extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-product-detail-swiper]');

      this.swiperOptions = {
        direction: 'horizontal',
      };

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
      Fancybox.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'image-zoom',
      });
    }
  }

  customElements.define('product-detail-swiper', ProductDetailSwiper);
}

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productForm = this.querySelector('product-form');
      this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
      this.quantityInput = this.querySelector('quantity-input');
      this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
      this.quantityInputElement?.addEventListener('change', () => {
        this.handleQuantityInput();
      });

      // fake variants feature
      this.fakeVariantActive = this.productForm?.querySelector('input[name="properties[Variant]"]');
      this.fakeVariants = this.querySelectorAll('[data-fake-variant]');
      this.fakeVariantError = this.querySelector('[data-fake-variants-error-message]');

      this.fakeVariants.forEach((fakeVariant) => {
        fakeVariant.addEventListener('click', () => {
          this.handleFakeVariant(fakeVariant);
        });
      });
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput() {
      this.productFormQuantity.value = this.quantityInputElement.value;
    }

    /**
     * handleFakeVariant
     * @description Set the fake variant from the fake variant web component to the product form web component.
     * @param {HTMLElement} fakeVariant
     */
    handleFakeVariant(fakeVariant) {
      // set the line item property in the hidden input
      this.fakeVariantActive.value = fakeVariant.dataset.fakeVariant;

      // set the line item property in the quantity input
      this.productFormQuantity.value = fakeVariant.dataset.fakeVariantQuantity;

      // remove the active class from all fake variants
      this.fakeVariants.forEach((fakeVariant) => {
        fakeVariant.classList.remove('active');
      });

      // add the active class to the clicked fake variant
      fakeVariant.classList.add('active');

      this.handleFakeVariantError();
    }

    /**
     * handleFakeVariantError
     * @description Handle the fake variant error message.
     */
    handleFakeVariantError() {
      // if there are fake variants, but none are active, show the error message and return false
      if (this.fakeVariants.length > 0 && !this.fakeVariantActive.value) {
        this.fakeVariantError.classList.remove('hidden');
        return false;
      }
      // if there are fake variants, and one is active, hide the error message and return true
      else if (this.fakeVariants.length > 0 && this.fakeVariantActive.value) {
        this.fakeVariantError.classList.add('hidden');
        return true;
      }
      // if there are no fake variants, hide the error message and return true
      else {
        return true;
      }
    }
  }
  customElements.define('product-info', ProductInfo);
}
